import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Chip,
  Grid,
  FormControlLabel,
  Switch,
  FormLabel,
} from '@material-ui/core';

import PropTypes from 'prop-types';

import { complementaryColor } from '../../utils/constants';
import translations from '../../languages/i18n';
import fieldStyles from '../../styles/fieldStyles';

const BlueSwitch = withStyles({
  switchBase: {
    color: 'default',
    '&$checked': {
      color: complementaryColor,
    },
    '&$checked + $track': {
      backgroundColor: complementaryColor,
    },
  },
  checked: {},
  track: {},
})(Switch);
export default function TimedOutSchedulesFilter(props) {
  const {
    timedOut, setTimedOut, days, setDays, daysOptions,
  } = props;

  const i18nTimeOutText = translations['_days'];
  const i18nLabel = translations['_timedOut'];
  const classesField = fieldStyles();

  return (
    daysOptions && (
      <div>
        <Grid container direction='row' alignItems='center'>
          <Grid item>
            <div style={{ alignItems: 'center' }}>
              <FormLabel className={classesField.formLabel}>{translations['_actives']}</FormLabel>
              <FormControlLabel
                control={(
                  <BlueSwitch
                    checked={timedOut}
                    onChange={(event) => {
                      if (event.target.checked === false) {
                        setDays(null);
                      }
                      setTimedOut(event.target.checked);
                    }}
                    name='timedOut'
                    color='primary'
                  />
                )}
                label={i18nLabel}
                className={classesField.formControlLabel}
              />
            </div>
          </Grid>
          <Grid item>
            <Chip
              disabled={!timedOut}
              color={days === daysOptions[0] ? 'primary' : undefined}
              label={`${daysOptions[0]} ${i18nTimeOutText}`}
              onClick={() => (days === daysOptions[0] ? setDays(null) : setDays(daysOptions[0]))}
            />
            <Chip
              disabled={!timedOut}
              color={days === daysOptions[1] ? 'primary' : undefined}
              label={`${daysOptions[1]}  ${i18nTimeOutText}`}
              onClick={() => (days === daysOptions[1] ? setDays(null) : setDays(daysOptions[1]))}
            />
            <Chip
              disabled={!timedOut}
              color={days === daysOptions[2] ? 'primary' : undefined}
              label={`${daysOptions[2]}  ${i18nTimeOutText}`}
              onClick={() => (days === daysOptions[2] ? setDays(null) : setDays(daysOptions[2]))}
            />
          </Grid>
        </Grid>
      </div>
    )
  );
}

TimedOutSchedulesFilter.propTypes = {
  timedOut: PropTypes.bool.isRequired,
  setTimedOut: PropTypes.func.isRequired,
  days: PropTypes.number,
  setDays: PropTypes.func.isRequired,
  daysOptions: PropTypes.array.isRequired,
};
